Namespace 'Customer.Filters'

class Customer.Filters.VisibilityView extends Backbone.View
  template: JST['backbone/templates/customer/filters/components/visibility']
  className: 'is-global d-flex align-items-center'

  initialize: ({@title, @visibility, @canManageGlobal, @editable}) ->

  render: ->
    @$el.html @template
      title: @title
      isPublic: @visibility.global
      canManageGlobal: @canManageGlobal
      editable: @editable
      lockVisibility: !(@editable && @canManageGlobal)
    @$el.find('.visibility-public').click(=> @_toggleGlobalVisibility(true))
    @$el.find('.visibility-private').click(=> @_toggleGlobalVisibility(false))
    @

  getVisibility: =>
    @visibility

  _toggleGlobalVisibility: (isPublic) =>
    @_keepCustomerSessionAlive()
    @visibility.global = isPublic
    @visibility.user_id = if isPublic then null else Keepcon.current_user.id
    @trigger('toggleVisibility', isPublic)

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'
